import React from 'react';
import { connect } from 'react-redux';
import { getOnboardingState, getAuthState } from '../../store/selectors';

export class CareerCategoriesAndImages extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {};
  }

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  backgroundPrimary = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  backgroundSecondary = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  borderBottom = {
    borderBottom: `4px solid ${this.props.tenant.secondary}`,
  };

  navBarIcon = {
    height: '27px',
    width: '25px',
  };

  activeElement = {
    color: `${this.props.tenant.primary}`,
    borderBottom: `3px solid ${this.props.tenant.secondary}`,
  };

  borderTopSecondary = {
    borderTop: `9px solid ${this.props.tenant.secondary}`,
  };

  render() {
    return (
      <>
        <div
          style={this.props.styling.mainContent}
          className="career-categories-and-images"
        >
          Career Categories and Images!
          <br />
          <br />
          <div style={this.props.styling.boxWithBoxShadow}>
            Box with Box Shadow
          </div>
          <br />
          <div style={this.props.styling.boxWithSecondaryUnderline}>
            Box with Secondary Underline
          </div>
          <br />
          <div style={this.props.styling.boxWithShadowAndUnderline}>
            Box with Shadow and Underline
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);

  return { onboarding, auth };
}

export default connect(mapStateToProps)(CareerCategoriesAndImages);
